import React from 'react';
import ProductVariant from 'modules/product/views/components/product-variants/components/product-variant';
import ProductVariantInterface from 'modules/product/interfaces/product-variant.interface';

import './product-variants.scss';

interface ProductVariantsProps {
    variants: ProductVariantInterface[];
}

const ProductVariants: React.FC<ProductVariantsProps> = ({
    variants
}) => {
    return (
        <ul className="product-variants" data-section="product-variants">
            {variants.map(variant => (
                <li
                    key={variant.variantId}
                >
                    <p className="product-variants__name">
                        {variant.variantName}:
                    </p>
                    <ul className="product-variants__options">
                        {variant.options.map(option => (
                            <li
                                key={option.optionId}
                            >
                                <ProductVariant
                                    isActive={option.isActive}
                                    isDisable={option.isDisable}
                                    name={option.optionName}
                                    url={option.url}
                                />
                            </li>
                        ))}
                    </ul>
                </li>
            ))}
        </ul>
    );
};

export default ProductVariants;
